import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { firebase } from '../../firebase/Firebase'
import '../../styles/GlobalStyle.css'
import {
    getStudentMayHaveTroubleWith, getIDFromURL, cleverIsAuthed, cleverGetStudents,
    isReadOnlyTeacherId
} from '../.././Util'
import { Layout, Row, Col, Button, Alert, Icon } from 'antd'
import CustomFooter from '../../login/CustomFooter'
import TeacherAddStudentsClever from './TeacherAddStudentsClever'
import ModalVideo from '../../customcomponents/ModalVideo'
//import AddStudentCSV from './AddStudentCSV'
const { Content } = Layout

class TeacherMeetings extends Component {
    state = {
        teacherId: '',
        modalVisible: false,
    }

    componentDidMount() {
        document.title = "Meetings - Dot It"

        var teacherId = getIDFromURL(window.location)

        this.setState({
            teacherId: teacherId,
        })
    }

    render() {
        return (
            <div>
                <Layout className="content layout-header-mt">
                    <Layout>
                        <Content className="layout-content">
                            <div className="sub-menu-width m-lr-auto">
                                <div className='br-20 overflow-hidden mb-3'>
                                    <div className='br-4 relative pl-3 pr-3 pt-3 relative'
                                        style={{ minHeight: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }}>


                                        <div className='absolute-tl w-100 h-100'>
                                            <div className='h-100'>
                                                <div className='flex flex-v-center font-40 font-fff w-100 h-100 p-4'>
                                                    <div className='w-100'>
                                                        <div className='font-40 font-bold font-fff'>MTSS & IEP</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='font-30 font-bold mb-2'>Create MTSS Tier Plan or IEP Goal</div>
                                <Button className='lg-btn mb-3 flex flex-v-center' type='primary'
                                    onClick={() => {
                                        this.setState({
                                            modalVisible: true,
                                        })
                                    }}
                                ><Icon type='play-circle' className='font-24 mr-05 mt-05' />See how it works</Button>

                                <Row gutter={32} className='pl-2 pr-2'>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="pl-0">
                                        <Link
                                            to={"/teacher/mtss-add-goal-student/" +
                                                this.state.teacherId}
                                            onClick={(e) => {
                                                if ((this.props.teacherBaseProps.teacher &&
                                                    isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id)) ||
                                                    (this.props.teacherBaseProps.students &&
                                                        this.props.teacherBaseProps.students.length === 0)) {
                                                    e.preventDefault()
                                                }
                                            }}
                                        >
                                            <div
                                                className={"p-2 br-20 background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 font-black overflow-hidden"}
                                                style={{ minHeight: '118px' }}
                                            >
                                                <div className="br-4 overflow-hidden">
                                                    <img src="/tier-two-three-icon.png" alt="tier 2 and 3 icon" height="64" />
                                                </div>
                                                <h2 className="ml-2 font-24 font-bold">
                                                    Draft an MTSS Tier Plan
                                                </h2>

                                                {(this.props.teacherBaseProps.teacher &&
                                                    isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id)) ||
                                                    (this.props.teacherBaseProps.students &&
                                                        this.props.teacherBaseProps.students.length === 0) ?
                                                    <div>
                                                        <div className="disabled-overlay">

                                                        </div>
                                                        {(this.props.teacherBaseProps.students &&
                                                            this.props.teacherBaseProps.students.length === 0) ?
                                                            <div className="absolute-tl w-100 font-16 cursor-disabled">
                                                                <Alert
                                                                    className="alert-vlg"
                                                                    message="You can draft a tier plan after adding a student."
                                                                    type="info"
                                                                    showIcon
                                                                />
                                                            </div> : ''}
                                                    </div> :
                                                    ''}
                                            </div>
                                        </Link>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12} className="pl-0">
                                        <Link
                                            to={"/teacher/add-goal-student/" + this.state.teacherId}
                                            onClick={(e) => {
                                                if ((this.props.teacherBaseProps.teacher &&
                                                    isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id)) ||
                                                    (this.props.teacherBaseProps.students &&
                                                        this.props.teacherBaseProps.students.length === 0)) {
                                                    e.preventDefault()
                                                }
                                            }}
                                        >
                                            <div
                                                className={"p-2 br-20 background-fff mb-3 ant-shadow ant-shadow-more-hover parent-hover relative flex flex-v-center font-20 font-black overflow-hidden"}
                                                style={{ minHeight: '118px' }}
                                            >
                                                <div className="br-4 overflow-hidden">
                                                    <img src="/add-iep.png" alt="home icon" height="64" />
                                                </div>
                                                <h2 className="ml-2 font-24 font-bold">
                                                    Draft an IEP
                                                </h2>

                                                {(this.props.teacherBaseProps.teacher &&
                                                    isReadOnlyTeacherId(this.props.teacherBaseProps.teacher.id)) ||
                                                    (this.props.teacherBaseProps.students &&
                                                        this.props.teacherBaseProps.students.length === 0) ?
                                                    <div>
                                                        <div className="disabled-overlay">

                                                        </div>
                                                        {(this.props.teacherBaseProps.students &&
                                                            this.props.teacherBaseProps.students.length === 0) ?
                                                            <div className="absolute-tl w-100 font-16 cursor-disabled">
                                                                <Alert
                                                                    className="alert-vlg"
                                                                    message="You can draft an IEP after adding a student."
                                                                    type="info"
                                                                    showIcon
                                                                />
                                                            </div> : ''}
                                                    </div> :
                                                    ''}
                                            </div>
                                        </Link>
                                    </Col>




                                </Row>
                            </div>
                        </Content>

                        <ModalVideo
                            title='See how it works'
                            visible={this.state.modalVisible}
                            onOk={() => {
                                this.setState({
                                    modalVisible: false,
                                })
                            }}
                            onCancel={() => {
                                this.setState({
                                    modalVisible: false,
                                })
                            }}
                            width={888}
                            src={'https://dotit.app/wp-content/themes/dotit/assets/2025/videos/IEP.mp4'}
                            className='p-0'
                        />
                    </Layout>
                </Layout>
                <CustomFooter />
            </div>
        )
    }
}

export default TeacherMeetings